import { type Dispatch, type ReactNode, type SetStateAction } from 'react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import { CloseCircle } from '@/components/ui/Close/Close';

import css from './styles.module.scss';

interface PlantNavigationProps<T extends object> {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  item: (props: T) => ReactNode | null;
  list?: T[];
  className?: string;
}

const PlantNavigation = <T extends object>({
  isOpen,
  setIsOpen,
  list,
  item,
  className,
}: PlantNavigationProps<T>): JSX.Element => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.nav
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{
            ease: 'linear',
            duration: 0.2,
          }}
          className={cn(css.plantNav, className)}
        >
          <CloseCircle
            variant="default"
            cross="default"
            onClick={() => {
              setIsOpen(false);
            }}
          />
          <div className="flex flex-col gap-1 items-end">
            {list?.map((props) => item(props))}
          </div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

export { PlantNavigation };
